import { render, staticRenderFns } from "./QuizOpinionScaleForm.vue?vue&type=template&id=fb0e378a&"
import script from "./QuizOpinionScaleForm.vue?vue&type=script&lang=ts&"
export * from "./QuizOpinionScaleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports